<template>
  <v-app>
<div style="padding-top:60px">
      <h2 style="text-align:center">News & Events</h2>
      
      <v-layout row wrap>
        <v-flex xs12 md3 sm12 style="padding:20px" v-for="owl in news" :key="owl.id">
            <v-card style="border-radius:0px;padding:0px;background-color:orange">
               <v-container>
                 <h5 style="padding-top:25px;color:#0d47a1">{{owl.title}}</h5>
               <p style="">({{owl.category}})</p>
               <p style="">{{owl.date}}</p>
               <p style="padding:5px;text-align:justify;" v-html="owl.description">
               </p>
                 
                 <div style="text-align:right;margin-top:-15px">
                   <v-btn small flat color="blue" @click="read(owl)">read more</v-btn>
                 </div>
               </v-container>
            </v-card>
          </v-flex>
      </v-layout>
      </div>
           
  </v-app>
</template>

<script>
import config from "./../../config.json";
import moment from 'moment';
export default {
  data() {
    return {
      icons: [
        'fab fa-facebook',
        'fab fa-twitter',
        'fab fa-google-plus',
        'fab fa-linkedin',
        'fab fa-instagram',
      ],
       items: [
          {
            src: 'https://api.supremogateway.com/api/Gallery/1',
          },
          {
            src: 'https://api.supremogateway.com/api/Gallery/2',
          },
          {
            src: 'https://api.supremogateway.com/api/Gallery/3',
          },
          {
            src: 'https://api.supremogateway.com/api/Gallery/4',
          },
          {
            src: 'https://api.supremogateway.com/api/Gallery/5',
          },
          {
            src: 'https://api.supremogateway.com/api/Gallery/6',
          },
          {
            src: 'https://api.supremogateway.com/api/Gallery/7',
          },
        ],
      valid: true,
      isLoading: false,

      owlCount: [],
      news: [],

      homePage: {
        productList: null,
        productCategoryList: null,
        recentMemberList: null,
        eventList: null
      },
    };
  },
  methods: {
    getData() {

      this.axios
      .get(config.API + `news/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;

        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          this.news.push({
            id: element.id,
            title: element.title,
            description: element.description,
            category: element.newscategory.categoryName,
            date: moment(String(element.createdAt)).format('MMMM DD, yyyy')
          })
        }

        console.log(this.countries);
      });
      
    },

    read(item) {
      this.$router.push("/newsDetail/" + item.id);
    },

    addToCart(item) {
        this.$store.commit('addToCart', item);
        item.available = item.available - 1;
    },

    category(owl) {
      this.$router.push("/categoryDetail/" + owl.id);
    }

  },

  mounted() {
    this.getData();
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Farro&display=swap');  
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@keyframes blink {
  from { background-color: purple; }
  to { background-color: red; }
}
.main {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.form-container {
  margin: 0px !important;
}
.swo {
  box-shadow: none !important;
}
.height {
  height: 5000px;
}
.login-form {
  width: 350px;
}
.call-button-container {
  margin: auto;
  width: 233px;
  height: 74px;
  vertical-align: middle;
  padding: 10px;
}
.sticky {
  position:fixed;
   top:0;
    width:100%;
    z-index:100;
}
.button :active {
animation: blink 0.02s 20 alternate;
}
.login-text {
  text-align: center;
}
.h1-text {
    text-align: right;
}
.padding {
  padding-left: 100px;
  padding-right: 100px;
  padding-bottom: 50px;
}
.custom {
	font-family: 'Farro', sans-serif;
	color: white;
	font-size:30px;
}
.custom1 {
  text-align: center;
	font-family: 'Farro', sans-serif;
	color: white;
	font-size:15px;
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 70px;
  color: yellow;
  font-weight: bold;
}
.hvr:hover {
  cursor: pointer;
  /* height: 200px; */
  border : 2px solid;
  border-color: black;
}
.custom2 {
  text-align: center;
	font-family: 'Farro', sans-serif;
	color: white;
	font-size:25px;
}
.progress-line {
  padding: 0px;
  margin: 0px;
}
.welcome-text {
  text-align: center;
  /* margin-top: 50px; */
  margin-bottom: 25px;
}
.tourtheme {
  height: 180px;
  border-radius: 0px;
  margin: 5px;
  background-size: cover;
}
.login-btn {
  color: #111;
  font-weight: bolder;
}
.bckcolor {
  background-size: cover;
  border-radius: 6px;
}
.autocomplete {
  height: 8px;
  width: 500px;
  padding: 25px;
  border-radius: 50px;
}
.bckcolor {
  background-image: linear-gradient(to right, rgb(36, 73, 90), green);
  background-size: cover;
  opacity: 0.8;
}
.bgclr {
  background-color: grey;
}
.prdct:hover {
  /* background-color: #c5e1a5 !important; */
  cursor: pointer;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important;
  /* color: white; */
}
.zindx {
  z-index: 9999;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
</style>
